<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    v-model="selectedMonth"
    item-text="title"
    item-value="value"
    :items="months"
    return-object
    v-on:input="$emit('input', $event)"
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  data: () => ({
    classes: [],
    loading: false,
    months: [],
    selectedMonth: null
  }),
  props: {
    month: Number
  },
  computed: {
    ...mapGetters('app', ['schoolYearStartDate', 'schoolYearEndDate'])
  },
  created() {
    const months = []
    let date = moment(this.schoolYearStartDate)
    while (moment(this.schoolYearEndDate).isSameOrAfter(date)) {
      const month = date.month() + 1
      const title = `Tháng ${month} / ${date.year()}`
      months.push({
        title,
        value: month,
        date: date.toISOString()
      })
      date = date.add(1, 'month')
    }

    this.months = months

    const currentMonth = moment().month() + 1
    this.selectedMonth = months.find(m => m.value === currentMonth)
    this.$emit('input', this.selectedMonth)
  },
  methods: {},
  watch: {}
}
</script>
